/**
 * Firebase-free helpers for working with already-fetched GLB model lists.
 *
 * This module must NOT import anything that initializes Firebase (no
 * `../firebase`, no `glbModelService`). Keeping `pickDefaultForType` here lets
 * pure render paths (e.g. the 2D elevation renderer) reuse the lookup without
 * pulling Firebase into their import chain.
 */

/**
 * Pick the per-type default from an already-fetched list of models.
 * Single source of truth for the `isDefaultForType` predicate so callers that
 * already hold a model list don't re-implement the lookup.
 * @param {Array<Object>} models - Models for a single object type
 * @returns {Object|null} The model flagged as default, or null if none is
 */
export const pickDefaultForType = (models) =>
  models?.find((model) => model.isDefaultForType === true) || null;
